import { IconButton } from "@mui/material";
import { exportIconButtonStyle } from "./Styles";

const ExportIconButton = ({ onClick, children, ...props }) => (
  <IconButton
    onClick={onClick}
    sx={exportIconButtonStyle}
    {...props}
  >
    {children}
  </IconButton>
);

export default ExportIconButton;